<ziro-text fieldId="destination" (input)="handleDestinationChange()"></ziro-text>
<ziro-text fieldId="label"></ziro-text>
<ziro-checkbox fieldId="callPickup"></ziro-checkbox>
